module.exports = "fragment DetailedGroupFragment on Group {\n  ...GroupFragment\n  members {\n    ...ContactFragment\n  }\n}\n"